export const APP_PUBLIC_NAME = {'es': 'Cámaras', 'en': 'Cameras'};
export const BACKEND : string = process.env.REACT_APP_BACKEND_URL ?? '';
